import React, { useEffect, useState } from 'react';
import { clientLink } from '../../utils/links';
import { fetchAccessToken } from '../../utils/accessToken';
interface ClientLinkProps {
  slug: string;
  projectId: string;
  /** Actions shown alongside, e.g. Preview as Client. */
  children?: React.ReactNode;
}

/**
 * The one link a client needs. Permanent per project, shared by everyone on
 * the client team, and copied from here into an email.
 *
 * Sits at the top of the project because sending it is one of the most
 * frequent things staff do. The full tokenised URL is not paraded — Copy Link
 * is the action. Nothing is shown until the project's stored access token has
 * been read, so a staff member can never copy a link that is missing it.
 */
export function ClientLink({
  slug,
  projectId,
  children
}: ClientLinkProps) {
  const [copied, setCopied] = useState(false);
  /* The project's own access token, used solely to build this link. */
  const [token, setToken] = useState('');
  const [checked, setChecked] = useState(false);
  const link = clientLink(slug, token);
  useEffect(() => {
    let live = true;
    setToken('');
    setChecked(false);
    void fetchAccessToken(slug, projectId).then(value => {
      if (!live) return;
      setToken(value);
      setChecked(true);
    });
    return () => {
      live = false;
    };
  }, [slug, projectId]);
  async function copy() {
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      /* Clipboard unavailable — the link is on screen to copy by hand. */
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  }
  return <div className="mt-9 flex flex-wrap items-center gap-x-5 gap-y-4" data-id="element-169" data-mp="lpqkg3gywn3x">
      <span className="label text-paper/40" data-id="element-170" data-mp="qokyyt7wjpi8">Client Link</span>

      {link ? <button type="button" onClick={copy} className="label border border-paper/40 px-5 py-3 text-paper transition-colors duration-150 ease-out hover:border-paper hover:bg-paper hover:text-ink" data-id="element-171" data-mp="1ef786ntn7ftt">
          {copied ? 'Copied ✓' : 'Copy Link'}
        </button> : <span className="label-sm text-paper/30" data-id="element-172" data-mp="1o21ci9x36h9c">
          {checked ? 'Secure link unavailable' : 'Preparing secure link…'}
        </span>}

      {children}
    </div>;
}